import { render, staticRenderFns } from "./ProkuraturaTizimi.vue?vue&type=template&id=7fc1fd80&scoped=true&"
import script from "./ProkuraturaTizimi.vue?vue&type=script&lang=js&"
export * from "./ProkuraturaTizimi.vue?vue&type=script&lang=js&"
import style0 from "./ProkuraturaTizimi.vue?vue&type=style&index=0&id=7fc1fd80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc1fd80",
  null
  
)

export default component.exports